import { inject, Injectable } from "@angular/core";
import { GlossSyncService } from "../../gloss.sync.service";
import { UserStoreService } from "../../../store/user/user.store.service";
import { ImportStoreService } from "../../../store/import/import.store.service";
import { ConfirmationDialogService } from "../../../confirmation/confirmation.service";
import { TransactionStoreService } from "../../../store/transaction/transaction.store.service";
import { AppStateStoreService } from "../../../store/app-state/app-state.store.service";
import { PlaidApi } from "../plaid.api";

@Injectable({
  providedIn: "root",
})
export class PlaidActions {
  protected glossSyncService = inject(GlossSyncService);
  protected userStore = inject(UserStoreService);
  protected importStore = inject(ImportStoreService);
  protected confirmationDialog = inject(ConfirmationDialogService);
  protected transactionStore = inject(TransactionStoreService);
  protected appState = inject(AppStateStoreService);
  protected plaidApi = inject(PlaidApi);
}
